import React from 'react';

const LanguageSwitcher = () => null;

export default LanguageSwitcher;
